import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, NgZone, OnDestroy, OnInit, inject } from '@angular/core';

import { Subscription } from 'rxjs';
import { CCOrganization } from '../model/organization/cc-org';



@Component({
    selector: 'app-org-toolbar-title',
    templateUrl: './org-toolbar-title.component.html',
    styleUrls: ['./org-toolbar-title.component.scss'],
    standalone: false
})
export class OrganizationToolbarTitleComponent implements OnInit, OnDestroy {
  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly ngZone = inject(NgZone);

  private readonly subcription: Subscription = new Subscription();


  @Input()
  value: CCOrganization | undefined;

  mobileMode = false;
  intervalId?: ReturnType<typeof setInterval>;
  time = new Date();

  ngOnDestroy() {
    this.subcription.unsubscribe();
    clearInterval(this.intervalId);
  }


  ngOnInit() {
    // Workaround for ng test
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        this.ngZone.run(() => {
          this.time = new Date();
        });
      }, 1000);
    });


    this.handleSizeChange();
    this.subcription.add(
      this.breakpointObserver.observe([Breakpoints.Handset,
      Breakpoints.Tablet, Breakpoints.Web]).subscribe(_v => {
        this.handleSizeChange();
      }));

  }


  private handleSizeChange() {
    this.mobileMode = this.breakpointObserver.isMatched(Breakpoints.Handset);
  }
}
